<template>
  <tabs :tabs="tabsFiltered" :entity-type="entityType" :entity-id="entityId" />
</template>

<script>
import { mapState } from 'vuex';

import Tabs from '@/components/tabs/Tabs';
import { TableName } from '@/enums/tableName';
import { isExternalUser } from '@/mixins/isExternalUser';

// @vuese
// Profil
// @group Profile
export default {
  components: { Tabs },

  mixins: [isExternalUser],
  props: {
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      entityType: TableName.profile
    };
  },
  computed: {
    ...mapState({
      entityId: state => state.profile.data.id.toString()
    }),
    tabsFiltered() {
      if (!this.isExternalUser) {
        return this.tabs;
      }
      return this.tabs.filter(tab => tab.title !== 'Edycja');
    }
  }
};
</script>
